import { createI18n } from 'vue-i18n'
import enMessages from '../locales/en.json'
import idMessages from '../locales/id.json'

function getLocale() {
  const localeMeta = document.querySelector('meta[name="locale"]')
  return (localeMeta && localeMeta.getAttribute('content')) || 'en'
}

const i18nInstance = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: 'en',
  messages: {
    en: enMessages,
    id: idMessages
  }
})

export const t = (key, params) => {
  return i18nInstance.global.t(key, params)
}

export default i18nInstance 
